// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h0fTJ","descriptionWrapper":"styles_descriptionWrapper__ehYJj","boldDescription":"styles_boldDescription__R0lDa","addInfo":"styles_addInfo__0UqJf"};